<!-- default modal -->
<div id="cxone-award-modal">
    <!-- Parent that resizes with the ngbModal, but the child will have min sizes with overflow scroll -->
    <div>
        <!-- Header -->
        <div>
            <div class="modal-header-container">
                <div>
                    <span class="modal-header-title" cvLocalizedText langSection="Manual_Awards"
                        langKey="Select_Award">Select award</span>
                </div>
                <button type="button" class="icon-btn" style="fill: #333333; color: #333333;" (click)="close()">
                    <svg class="icon-16">
                        <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                    </svg>
                </button>
            </div>
            <!-- Search -->
            <div class="d-flex justify-content-between align-items-center" style="margin-left:24px;">
                <div class="d-flex">
                    <span class="content-text" cvLocalizedText langSection="Manual_Awards" langKey="Award_To">Award
                        to</span>
                    <span>&nbsp;</span>
                    <span class="content-text-bold">{{selectedRow.groupName}}</span>
                </div>
                <div class="search-container">
                    <sol-text-input class="w-100"
                        [placeholderText]="getLocalizationString('Search_For_Awards','Search for awards')" type="search"
                        [leadingIcon]="icon" [(ngModel)]="searchValue" (ngModelChange)="filterByRuleName()"
                        (ngModelChangeDebounced)="searchValue" [ngModelChangeDebounceTime]="400">
                    </sol-text-input>
                </div>
                <ng-template #icon>
                    <svg class="icon-16">
                        <use href="../App_Themes/CXone/icons/gamification/cxone-sol-search.svg#cxone-sol-search">
                        </use>
                    </svg>
                </ng-template>
            </div>
        </div>
        <!-- Page loader -->
        <div *ngIf="isLoading" class="no-content-containers mt-2">
            <cv-loader class="cxone-loader" [size]="'large'" [loaderType]="'cxone'" [overlay]="true"></cv-loader>
        </div>
        
        <!-- No results found -->
        <div *ngIf="!isLoading && filteredFolders.length === 0 && folders.length !== 0">
            <div class="no-content-containers flex-column mt-2">
                <svg>
                    <use href="../App_Themes/CXone/icons/no-results-big.svg#no-results-big"></use>
                </svg>
                <p cvLocalizedText langSection="Manual_Awards" langKey="No_Results_Found" class="no-results-label">No
                    results found</p>
            </div>
        </div>
        <!-- Empty state -->
        <div *ngIf="!isLoading && folders.length === 0">
            <div class="no-content-containers flex-column mt-2">
                <svg>
                    <use href="../App_Themes/CXone/icons/cxone-no-items.svg#cxone-no-items"></use>
                </svg>
                <p cvLocalizedText langSection="Manual_Awards" langKey="No_Award_Added_Yet" class="no-results-label">No
                    results found</p>
            </div>
        </div>
        <!-- Content -->
        <overlay-scrollbars class="accordion-scroll-container" [options]="scrollOptions"
            *ngIf="!isLoading && filteredFolders.length !== 0 && folders.length !== 0">
            <ngb-accordion class="w-100" #acc="ngbAccordion" [destroyOnHide]="false" [activeIds]="foldersKeyValues">
                <!-- Panel -->
                <ngb-panel ngbAccordionItem *ngFor="let folder of filteredFolders; let i = index" [id]="i.toString()">
                    <ng-template ngbPanelHeader let-opened="opened">
                        <button ngbPanelToggle class="accordion-selector-button">
                            <div><span class="accordion-title">{{folder.Key}}</span></div>
                            <svg class="icon-16 accordion-arrow" [class.d-none]="opened">
                                <use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right">
                                </use>
                            </svg>
                            <svg class="icon-16 accordion-arrow" [class.d-none]="!opened">
                                <use href="../App_Themes/clearview-default/icons/utility/arrow-down.svg#arrow-down">
                                </use>
                            </svg>
                        </button>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="card-container-wrapper">
                            <cv-cxone-select-award-card *ngFor="let awards of folder.Value"
                                [awardName]="awards.rule.RuleName" [coins]="awards.coinAmount"
                                [badgeImage]="awards.badgeImageID"
                                [isSelected]="isSelected(awards)"
                                (click)="saveSelectedAward(awards)"
                            ></cv-cxone-select-award-card>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </overlay-scrollbars>
        <!-- Footer -->
        <div class="give-award-container">
            <div class="d-flex justify-content-end">
                <button type="button" [disabled]="disableButton" [ngClass]="disableButton ? 'sol-button-disabled' : 'sol-button-primary'" [ngbPopover]="popRules"
                    #p="ngbPopover" [class.active]="p.isOpen()" placement="left" triggers="click" popoverClass="awards-confirm-tooltip-container">
                    <span cvLocalizedText langSection="Manual_Awards" langKey="Give_Award">
                        Give award
                    </span>
                </button>
                <ng-template #popRules class="modal-tooltip" >
                    <div>
                        <span class="content-text" style="padding-bottom: 10px;color:white !important;">{{confirmationMessage}}</span>
                        <div style="height: 10px;"></div>
                        <div class="d-flex">
                            <button class="modal-btn modal-btn-secondary mr-2" (click)="p.close()">
                                <span cvLocalizedText langSection="Manual_Awards" langKey="No">No</span>
                            </button>
                            <button class="modal-btn modal-btn-primary" (click)="giveAward(); p.close()" [disabled]="isGivingAward">
                                <span cvLocalizedText langSection="Manual_Awards" langKey="Yes">Yes</span>
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
